/**
 * CSS Custom Properties
 *
 * These properties can be overridden using the component's tag as selector.
 *
 * @prop --calcite-table-cell-background: Specifies the background color of the component.
 */

:host {
  --calcite-internal-table-cell-background: var(--calcite-table-cell-background, transparent);
  @apply contents;
}

:host([alignment="center"]) td:not(.selection-cell):not(.number-cell) {
  @apply text-center;
}

:host([alignment="end"]) td:not(.selection-cell):not(.number-cell) {
  @apply text-end;
}

.assistive-text {
  @apply sr-only;
}

td {
  @apply text-start align-middle text-color-1 whitespace-normal;
  background: var(--calcite-internal-table-cell-background);
  font-size: var(--calcite-internal-table-cell-font-size);
  border-inline-end: 1px solid var(--calcite-color-border-3);
  padding: var(--calcite-internal-table-cell-padding);

  &:not(.static-cell) {
    @apply focus-base;
    &:focus {
      @apply focus-inset;
    }
  }
}

td.start.content-cell {
  @apply align-top;
}

td.end.content-cell {
  @apply align-bottom;
}

td.last-cell {
  border-inline-end: 0;
}

.number-cell {
  @apply bg-foreground-2;
}

.footer-cell {
  @apply bg-background font-medium text-color-1;
  border-block-start: 1px solid var(--calcite-color-border-3);
}

.number-cell,
.selection-cell {
  @apply text-center;
  border-inline-end: 1px solid var(--calcite-color-border-3);
  inline-size: 2rem;
  min-inline-size: 2rem;
}

.selection-cell {
  @apply text-color-3;
  inset-inline-start: 2rem;
  &:not(.footer-cell) {
    @apply cursor-pointer;
  }
}

.selected-cell:not(.number-cell):not(.footer-cell) {
  --calcite-internal-table-cell-background: var(--calcite-color-foreground-current);
}

.selection-cell.selected-cell {
  box-shadow: inset 0.25rem 0 0 0 var(--calcite-color-brand);
  color: var(--calcite-color-brand);
  & calcite-icon {
    color: var(--calcite-color-brand);
  }
}

.calcite--rtl.selection-cell.selected-cell {
  box-shadow: inset -0.25rem 0 0 0 var(--calcite-color-brand);
}

.selection-cell {
  @apply align-middle;
  & ::slotted(calcite-icon) {
    @apply pointer-events-none mt-1;
  }
}

@include disabled();
